module.exports = __webpack_public_path__ + "static/media/(DH)_MG_5980_-_Cia_Termal_Beachewear_-_Moda_Feminina.63f17baf.jpg";